import type { ValueOf } from 'type-fest';

export const API_GATEWAY_STATUS_CODE = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  PRECONDITION_FAILED: 412,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export type ApiGatewayStatusCode = ValueOf<typeof API_GATEWAY_STATUS_CODE>;

export class ErrorAPIGatewayDTO {
  code!: ApiGatewayStatusCode;
  message!: string;
  errorCode?: number;
  data?: Record<string, unknown>;

  constructor(opts?: Record<string, any>) {
    if (opts) Object.keys(this).forEach((key) => (this[key] = opts[key]));
  }
}
